import { render, staticRenderFns } from "./CardRecollects.vue?vue&type=template&id=bde64bf8"
import script from "./CardRecollects.vue?vue&type=script&lang=js"
export * from "./CardRecollects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports